import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartItemComponent } from './cart-item.component';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { RouterModule } from '@angular/router';
import { NumberInputModule } from '@fgb/portal-component-library/src/lib/shared/number-input';

@NgModule({
  declarations: [CartItemComponent],
  imports: [
    CommonModule,
    PipesModule,
    RouterModule,
    NumberInputModule,
    FGBSharedModule
  ],
  exports: [CartItemComponent],
})
export class CartItemModule {}
